window.global ||= window;

// Global light dom styles.
import '@liebherr/patternlib/dist/patternlib/patternlib.css';
// Liebherr web fonts.
import '@liebherr/patternlib/www/assets/css/patternlib-fonts.css';
import '@/assets/tailwind.css';

import { createApp } from 'vue';
// Calls applyPolyfills and defineCustomElements from the main package internally.
import { PatternLibraryPlugin } from '@liebherr/patternlib-vue';

import { createPinia } from 'pinia';
const pinia = createPinia();

import App from '@/App.vue';
import router from '@/router';

// Highlighter
import 'highlight.js/styles/stackoverflow-light.css';
import 'highlight.js/lib/common';
import hljsVuePlugin from '@highlightjs/vue-plugin';

// Looks unused, but needed to get the trick above going
import FormattersPlugin from '@/plugins/formatter.js';

import { useI18nStore } from '@/stores/I18nStore';

import { i18n } from '@/../I18n';

async function loadRuntimeConfig(): Promise<void> {
    const res = await fetch('/runtime-config/config.json');
    const config = await res.json();
    window.RUNTIME_CONFIG = config;
}

loadRuntimeConfig().then(() => {
  const app = createApp(App);
  app.use(router);
  app.use(i18n);
  app.use(pinia);
  app.use(PatternLibraryPlugin);
  app.use(FormattersPlugin);
  app.use(hljsVuePlugin);

  const i18nStore = useI18nStore();
  i18nStore.init();

  app.mount('#app');
})

export default i18n.global;
